import React from 'react';
import ProgrammingHero from '../../images/logos/programmingHeroLogo.png';
import FreeCodeCamp from '../../images/logos/freeCodeCamp.jpg';
import CodemanBD from '../../images/logos/codemanBD.png';
import Elementor from '../../images/logos/elementor.jpg';
import Firebase from '../../images/logos/firebase.png';
// import Heroku from '../../images/logos/heroku.jpg'; 
import Nelify from '../../images/logos/netlify.png';
import reactRouter from '../../images/logos/router.png';
import JSES6 from '../../images/logos/es6.png';
import Mongoose from '../../images/logos/mongoose.png';
import Material from '../../images/logos/material.png';
import Redux from '../../images/logos/redux.png';
import GoogleMap from '../../images/logos/googleMap.jpg';
import Sidebar from '../Sidebar/Sidebar';
import NavBar from '../NavBar/NavBar';
import './Resume.css';
import Fade from 'react-reveal/Fade';

const Resume = () => {
    return (
        <div className="container-fluid">
          <div className="row">
              <Sidebar></Sidebar>
              <div className="col-md-9 col-sm-12 col-12 bg-green-opacity main-area">
                <div className="header">
                  <div className="progress-container">
                    <div className="progress_bar" id="myBar"></div>
                  </div>
                </div> 
                  <div className="container">
                    <div className="row mb-2">
                      <Fade bottom>
                        <div className="resume_area col-md-10 skills bg-white shadow-lg rounded w-100 mt-5 mx-3 pt-4 px-4 pb-5">
                            <h2 className="h2-responsive text-center mb-4">SKILLS</h2>
                            <div className="row">
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center w-100 p-3 hvr-grow">
                                    <i className="devicon-javascript-plain colored"></i>
                                    <p className="mb-0 p-responsive">javascript</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-2 pt-3">
                                    <img className="w-50 mb-1" src={JSES6} alt={JSES6} />
                                    <p className="mb-0 p-responsive">ES6</p>
                                </div>
                              </div>
                              <div className="col-md col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-react-original colored"></i>
                                    <p className="mb-0 p-responsive">ReactJS</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-nodejs-plain colored"></i>
                                    <p className="mb-0 p-responsive">NodeJS</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-express-original colored"></i>
                                    <p className="mb-0 p-responsive">ExpressJS</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-2 pt-3">
                                    <img className="w-75 mb-2" src={Redux} alt={Redux} />
                                    <p className="mb-0 p-responsive">Redux</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-mongodb-plain colored"></i>
                                    <p className="mb-0 p-responsive">MongoDB</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 px-2 pb-3 pt-4">
                                    <img className="w-75 mb-1" src={Mongoose} alt={Mongoose} />
                                    <p className="mb-0 p-responsive">Mongoose</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-sass-original colored"></i>
                                    <p className="mb-0 p-responsive">Sass</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-html5-plain colored"></i>
                                    <p className="mb-0 p-responsive">HTML</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-css3-plain colored"></i>
                                    <p className="mb-0 p-responsive">CSS</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-bootstrap-plain colored"></i>
                                    <p className="mb-0 p-responsive">Bootstrap</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 px-1 pb-2 pt-3">
                                    <img className="w-50 mb-0" src={Material} alt={Material} />
                                    <p className="mb-0 p-responsive">Material Ui</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-wordpress-plain colored"></i>
                                    <p className="mb-0 p-responsive">WP</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-php-plain colored"></i>
                                    <p className="mb-0 p-responsive">PHP</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-mysql-plain colored"></i>
                                    <p className="mb-0 p-responsive">MySQL</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-c-plain colored"></i>
                                    <p className="mb-0 p-responsive">C</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-cplusplus-plain colored"></i>
                                    <p className="mb-0 p-responsive">C++</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-csharp-plain colored"></i>
                                    <p className="mb-0 p-responsive">C#</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-2 pt-3">
                                    <img className="w-50 mb-1" src={Elementor} alt={Elementor} />
                                    <p className="mb-0 p-responsive">Elementor</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-2 pt-3">
                                    <img className="w-50 mb-1" src={Firebase} alt={Firebase} />
                                    <p className="mb-0 p-responsive">Firebase</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-heroku-original colored"></i>
                                    <p className="mb-0 p-responsive">Heroku</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-2 pt-3">
                                    <img className="w-50 mb-1" src={Nelify} alt={Nelify} />
                                    <p className="mb-0 p-responsive">Nelify</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 px-1 pt-0">
                                    <img className="w-50 mb-0" src={reactRouter} alt={reactRouter} />
                                    <p className="mb-0 p-responsive">React Router</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-npm-original-wordmark colored"></i>
                                    <p className="mb-0 p-responsive">npm</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-git-plain colored"></i>
                                    <p className="mb-0 p-responsive">Git</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-github-plain colored"></i>
                                    <p className="mb-0 p-responsive">GitHub</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 p-3">
                                    <i className="devicon-trello-plain colored"></i>
                                    <p className="mb-0 p-responsive">Trello</p>
                                </div>
                              </div>
                              <div className="col-md-2 col-sm-4 col-xs-6 col-6 mb-3">
                                <div className="single-skill border border-color rounded text-center hvr-grow w-100 px-2 pt-1">
                                    <img className="w-75 mb-2" src={GoogleMap} alt={GoogleMap} />
                                    <p className="mb-0 p-responsive">Google Map API</p>
                                </div>
                              </div>
                            </div>
                        </div>
                      </Fade>
                    </div>

                    {/* Work Experience Area */}
                    <div className="row mb-4">
                      <div className="work_experience_area col-md-10 bg-white shadow-lg rounded w-100 mt-5 mx-3 pt-4 px-4 pb-5">
                          <h2 className="h2-responsive text-center mb-4">Work Experience</h2>
                            {/* <!--first section--> */}
                            <div className="row align-items-center how-it-works d-flex">
                              <div className="col-1 col-md-2 timeline_2 text-center bottom d-inline-flex justify-content-center align-items-center">
                                <div className="circle font-weight-bold"><i className="fa fa-book" aria-hidden="true"></i></div>
                              </div>
                              <Fade right>
                                <div className="col-10 col-md-9 mb-3">
                                  <div className="work_experience">
                                    <div className="work_experience_header text-white rounded py-3 pl-3">
                                      <h6 className="h6-responsive ml-2 mb-0"><i className="fa fa-calendar mr-2" aria-hidden="true"></i>December, 2020 - Present</h6>
                                    </div>
                                    <div className="work_experience_details bg-white text-secondary shadow-lg rounded ml-2 py-3 px-4">
                                      <h4 className="h4-responsive">Web Development Intern</h4>
                                      <h6 className="h6-responsive"><i className="fa fa-building-o mr-2" aria-hidden="true"></i>Molog Media and Advertising</h6>
                                      <p className="text-secondary my-1">Working on projects technologies using JavaScript, ReactJS, NodeJs, ExpressJs, MongoDB, Mongoose, Sass, UI Development, HTML5, CSS3 etc</p>
                                      <p className="text-dark"><i className="fa fa-map-marker mr-1" aria-hidden="true"></i> Hariyana, Panjab, India(Remote)</p>
                                    </div>
                                  </div>
                                </div>
                              </Fade>
                            </div>
                            {/* <!--path between 1-2--> */}
                            <div className="row timeline">
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner top-right"></div>
                              </div>
                              <div className="col-10 col-md-8">
                                <hr/>
                              </div>
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner left-bottom"></div>
                              </div>
                            </div>
                            {/* <!--second section--> */}
                            <div className="row align-items-center justify-content-end how-it-works d-flex">
                              <Fade left>
                                <div className="col-10 col-md-9 mb-3 text-right animate__animated animate__fadeInUp">
                                  <div class="work_experience">
                                    <div class="work_experience_header text-white rounded py-3 pr-2">
                                      <h6 class="h6-responsive mr-2 mb-0">January, 2020 - August, 2020<i class="fa fa-calendar ml-2" aria-hidden="true"></i></h6>
                                    </div>
                                    <div class="work_experience_details bg-white text-secondary shadow-lg rounded mr-1 py-3 px-4">
                                      <h4 class="h4-responsive">Web Developer</h4>
                                      <h6 class="h6-responsive"><i class="fa fa-building-o mr-2" aria-hidden="true"></i>Fiverr</h6>
                                      <p class="text-secondary my-1">Completed 52 projects from different countries clients. Worked with WordPress, Elementor, Elementor Pro, WordPress Theme Customization, WordPress Plugin Customization, Gravity Form, MailChimp etc.</p>
                                      <p class="text-dark"><i class="fa fa-map-marker mr-1" aria-hidden="true"></i> Work From Home</p>
                                    </div>
                                  </div>
                                </div>
                              </Fade>
                              <div className="col-1 col-md-2 timeline_2 text-center full d-inline-flex justify-content-center align-items-center">
                                <div className="circle font-weight-bold"><i className="fa fa-book" aria-hidden="true"></i></div>
                              </div>
                            </div>
                            {/* <!--path between 2-3--> */}
                            <div className="row timeline">
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner right-bottom"></div>
                              </div>
                              <div className="col-10 col-md-8">
                                <hr/>
                              </div>
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner top-left"></div>
                              </div>
                            </div>
                            {/* <!--third section--> */}
                            <div className="row align-items-center how-it-works d-flex">
                              <div className="col-1 col-md-2 timeline_2 text-center top d-inline-flex justify-content-center align-items-center">
                                <div className="circle font-weight-bold"><i className="fa fa-book" aria-hidden="true"></i></div>
                              </div>
                              <Fade right>
                                <div className="col-10 col-md-9 mb-3">
                                  <div class="work_experience">
                                    <div class="work_experience_header text-white rounded py-3 pl-3">
                                      <h6 class="h6-responsive ml-2 mb-0"><i class="fa fa-calendar mr-2" aria-hidden="true"></i>September, 2017 - December, 2017</h6>
                                    </div>
                                    <div class="work_experience_details bg-white text-secondary shadow-lg rounded ml-2 py-3 px-4">
                                      <h4 class="h4-responsive">Intern Software Engineer</h4>
                                      <h6 class="h6-responsive"><i class="fa fa-building-o mr-2" aria-hidden="true"></i>Access Tech Bd</h6>
                                      <p class="text-secondary my-1">Developed a desktop application for hospital automation system with C#, Crystal Report, SQL server.</p>
                                      <p class="text-dark"><i class="fa fa-map-marker mr-1" aria-hidden="true"></i> Uttara, Dhaka, Bangladesh</p>
                                    </div>
                                  </div>
                                </div>
                              </Fade>
                            </div>
                      </div>
                    </div>

                    {/* Courses Area */}
                    <div className="row mb-4">
                      <div className="courses_area col-md-10 bg-white shadow-lg rounded w-100 mt-5 mx-3 pt-4 px-4 pb-5">
                          <div className="container">
                            <h2 className="h2-responsive pb-3 pt-2 mb-4 text-center">Course Completed</h2>
                            {/* <!--first section--> */}
                            <div className="row align-items-center how-it-works d-flex">
                              <div className="col-1 col-md-2 timeline_2 text-center bottom d-inline-flex justify-content-center align-items-center">
                                <div className="circle font-weight-bold"><i className="fa fa-book" aria-hidden="true"></i></div>
                              </div>
                                <Fade right>
                                  <div className="col-10 col-md-9 mb-3">
                                    <div className="courses_header text-white rounded py-3 pl-3">
                                      <h6 className="h6-responsive m-0 ml-2"> Complete Web Development Course</h6>
                                    </div>
                                    <div className="courses_details bg-white text-secondary shadow-lg rounded ml-1 py-3 px-4">
                                        <h4 className="h4-responsive m-0"><img src={ProgrammingHero} className="mr-1" alt={ProgrammingHero} /> Programming Hero</h4>
                                        <p className="text-secondary my-3">JavaScript, ReactJS, NodeJs, ExpressJs, MongoDB, Mongoose, HTML, CSS, Bootstrap, Material UI, React Router, React Hooks, React Hook Form, Google Map API, SASS</p>
                                        <p className="text-dark"><i className="fa fa-calendar mr-2" aria-hidden="true"></i> July, 2020 - December, 2020</p>
                                    </div>
                                  </div>
                                </Fade>
                            </div>
                            {/* <!--path between 1-2--> */}
                            <div className="row timeline">
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner top-right"></div>
                              </div>
                              <div className="col-10 col-md-8">
                                <hr/>
                              </div>
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner left-bottom"></div>
                              </div>
                            </div>
                            {/* <!--second section--> */}
                            <div className="row align-items-center justify-content-end how-it-works d-flex">
                              <Fade left>
                                <div className="col-10 col-md-9 mb-3 text-right">
                                  <div className="courses_header text-white rounded py-3 pr-2">
                                    <h6 className="h6-responsive m-0 mr-4"> Responsive Web Design</h6>
                                  </div>
                                  <div className="courses_details bg-white shadow-lg rounded mr-1 py-3 px-4">
                                      <h4 className="h4-responsive m-0"><img src={FreeCodeCamp} alt={FreeCodeCamp} className="mr-2" />freeCodeCamp</h4>
                                      <p className="text-secondary my-2">Basic HTML & HTML5, Basic CSS, Applied Visual Design, Applied Accessibility, Responsive Web Design Principles, CSS Flexbox, CSS Grid, Responsive Web Design Projects</p>
                                      <p className="text-dark"><i className="fa fa-calendar mr-2" aria-hidden="true"></i> July, 2020 - August, 2020</p>
                                  </div>
                                </div>
                              </Fade>
                              <div className="col-1 col-md-2 timeline_2 text-center full d-inline-flex justify-content-center align-items-center">
                                <div className="circle font-weight-bold"><i className="fa fa-book" aria-hidden="true"></i></div>
                              </div>
                            </div>
                            {/* <!--path between 2-3--> */}
                            <div className="row timeline">
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner right-bottom"></div>
                              </div>
                              <div className="col-10 col-md-8">
                                <hr/>
                              </div>
                              <div className="col-1 col-md-2 timeline_2">
                                <div className="corner top-left"></div>
                              </div>
                            </div>
                            {/* <!--third section--> */}
                            <div className="row align-items-center how-it-works d-flex">
                              <div className="col-1 col-md-2 timeline_2 text-center top d-inline-flex justify-content-center align-items-center">
                                <div className="circle font-weight-bold"><i className="fa fa-book" aria-hidden="true"></i></div>
                              </div>
                              <Fade right>
                                <div className="col-10 col-md-9 mb-3">
                                  <div className="courses_header text-white rounded py-3 pr-2 pl-2">
                                    <h6 className="h6-responsive m-0 ml-3"> Elementor, WooCommerce & Wordpress</h6>
                                  </div>
                                  <div className="courses_details bg-white shadow-lg rounded mr-1 py-3 px-4">
                                      <h4 className="h4-responsive m-0 h4-responsive"><img src={CodemanBD} alt={CodemanBD} className="mr-2" />CodemanBD</h4>
                                      <p className="text-secondary my-2">Elementor, Wordpress Theme Customization, Gravity Form, WooCommerce, MailChimp etc.</p>
                                      <p className="text-dark"><i className="fa fa-calendar mr-2" aria-hidden="true"></i> October, 2019 - January, 2020</p>
                                  </div>
                                </div>
                              </Fade>
                            </div>
                          </div>
                      </div>
                    </div>

                    {/* Educational Qualification */}
                    <div className="row mb-4">
                      <Fade bottom>
                        <div className="education_area col-md-10 bg-white shadow-lg rounded w-100 mt-5 mx-3 pt-4 px-4 pb-5">
                            <h2 className="text-center mb-4">Educational Qualification</h2>
                            <div className="education">
                              <div className="education_header text-white rounded py-3 pl-3">
                                <h6 className="h6-responsive m-0"><i className="fa fa-calendar mr-2" aria-hidden="true"></i>January, 2013 - December, 2017</h6>
                              </div>
                              <div className="education_details bg-white text-secondary shadow-lg rounded ml-2 py-3 px-4">
                                  <h4 className="h4-responsive">Bachelor of Computer Science & Engineering</h4>
                                  <h6 className="h6-responsive"><i className="fa fa-graduation-cap mr-1" aria-hidden="true"></i>International University of Business Agriculture & Technology</h6>
                                  <p className="text-dark"><i className="fa fa-map-marker mr-1" aria-hidden="true"></i> Uttara, Dhaka, Bangladesh</p>
                              </div>
                            </div>
                    <br/><br/>
                        </div>
                      </Fade>
                    </div>
                  </div>
                  <NavBar></NavBar>
              </div>
          </div>
        </div>
    );
};

export default Resume;